import { __decorate } from "tslib";
import { Component, ViewChild } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { Select } from '@ngxs/store';
import { BaseComponent } from '@shared/components/base/base.component';
import { MarkNotificationsAsRead, PatchNotificationStatus } from '@store/notifications/notifications.actions';
import { NotificationsState } from '@store/notifications/notifications.state';
import { takeUntil, tap } from 'rxjs/operators';
import { flatten } from '../../../../../shared/utils/flatten/flatten';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "@angular/common";
import * as i3 from "@angular/material/button";
import * as i4 from "@angular/material/menu";
import * as i5 from "@fortawesome/angular-fontawesome";
import * as i6 from "@ngneat/transloco";
import * as i7 from "@angular/material/progress-spinner";
function NotificationsComponent_ng_container_0_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const count_r503 = ctx.ngIf;
    i0.ɵɵproperty("hidden", !count_r503);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(count_r503);
} }
function NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const t_r506 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", t_r506("noResults"), " ");
} }
function NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_div_9_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const notification_r510 = i0.ɵɵnextContext(2).$implicit;
    const t_r506 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", t_r506("states." + notification_r510.type + "." + notification_r510.status), " ");
} }
function NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_div_9_ng_container_2_ng_container_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const action_r517 = i0.ɵɵnextContext().$implicit;
    const t_r506 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵtextInterpolate(t_r506("actions." + action_r517.value));
} }
function NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_div_9_ng_container_2_ng_container_1_button_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_div_9_ng_container_2_ng_container_1_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r527 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵlistener("click", function NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_div_9_ng_container_2_ng_container_1_button_3_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r527); const action_r517 = i0.ɵɵnextContext().$implicit; const notification_r510 = i0.ɵɵnextContext(3).$implicit; const ctx_r525 = i0.ɵɵnextContext(4); return ctx_r525.dispatch(notification_r510, action_r517.value); });
    i0.ɵɵtemplate(1, NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_div_9_ng_container_2_ng_container_1_button_3_ng_container_1_Template, 1, 0, "ng-container", 28);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r518 = i0.ɵɵreference(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r518);
} }
function NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_div_9_ng_container_2_ng_container_1_button_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_div_9_ng_container_2_ng_container_1_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r532 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 29);
    i0.ɵɵlistener("click", function NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_div_9_ng_container_2_ng_container_1_button_4_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r532); const action_r517 = i0.ɵɵnextContext().$implicit; const notification_r510 = i0.ɵɵnextContext(3).$implicit; const ctx_r530 = i0.ɵɵnextContext(4); return ctx_r530.dispatch(notification_r510, action_r517.value); });
    i0.ɵɵtemplate(1, NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_div_9_ng_container_2_ng_container_1_button_4_ng_container_1_Template, 1, 0, "ng-container", 28);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r518 = i0.ɵɵreference(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r518);
} }
function NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_div_9_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_div_9_ng_container_2_ng_container_1_ng_template_1_Template, 1, 1, "ng-template", null, 24, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(3, NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_div_9_ng_container_2_ng_container_1_button_3_Template, 2, 1, "button", 25);
    i0.ɵɵtemplate(4, NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_div_9_ng_container_2_ng_container_1_button_4_Template, 2, 1, "button", 26);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const action_r517 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", action_r517.primary);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !action_r517.primary);
} }
function NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_div_9_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_div_9_ng_container_2_ng_container_1_Template, 5, 2, "ng-container", 23);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const notification_r510 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", notification_r510.actions);
} }
function NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtemplate(1, NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_div_9_span_1_Template, 2, 1, "span", 21);
    i0.ɵɵtemplate(2, NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_div_9_ng_container_2_Template, 2, 1, "ng-container", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const notification_r510 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", notification_r510.status !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !notification_r510.status);
} }
function NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "div", 16);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 17);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 18);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_div_9_Template, 3, 2, "div", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const notification_r510 = ctx.$implicit;
    const t_r506 = i0.ɵɵnextContext().$implicit;
    const ctx_r508 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("new", !notification_r510.hasRead);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 5, notification_r510.type));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 7, notification_r510.createdAt));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", t_r506("contents." + notification_r510.type, ctx_r508.flatten(notification_r510)), " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", notification_r510.actions);
} }
const _c0 = function (a0) { return { count: a0 }; };
function NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r538 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵlistener("click", function NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_Template_div_click_1_listener($event) { i0.ɵɵrestoreView(_r538); return $event.stopPropagation(); });
    i0.ɵɵelementStart(2, "div", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_4_Template, 2, 1, "div", 11);
    i0.ɵɵelementStart(5, "div", 12);
    i0.ɵɵtemplate(6, NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_div_6_Template, 10, 9, "div", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const t_r506 = ctx.$implicit;
    const notificationsState_r499 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("new", notificationsState_r499.unreadCount);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", t_r506("title", i0.ɵɵpureFunction1(4, _c0, notificationsState_r499.unreadCount)), " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !notificationsState_r499.collection.length);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", notificationsState_r499.collection);
} }
function NotificationsComponent_ng_container_0_ng_container_7_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelement(1, "mat-spinner", 31);
    i0.ɵɵelementEnd();
} }
function NotificationsComponent_ng_container_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NotificationsComponent_ng_container_0_ng_container_7_ng_container_1_Template, 7, 6, "ng-container", 7);
    i0.ɵɵtemplate(2, NotificationsComponent_ng_container_0_ng_container_7_div_2_Template, 2, 0, "div", 8);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const notificationsState_r499 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("translocoRead", "app.nav.auth.notifications");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !notificationsState_r499.isInitialized);
} }
const _c1 = function () { return ["fas", "inbox"]; };
function NotificationsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 1);
    i0.ɵɵelement(2, "fa-icon", 2);
    i0.ɵɵtemplate(3, NotificationsComponent_ng_container_0_span_3_Template, 2, 2, "span", 3);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "mat-menu", 4, 5);
    i0.ɵɵtemplate(7, NotificationsComponent_ng_container_0_ng_container_7_Template, 3, 2, "ng-container", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const notificationsState_r499 = ctx.ngIf;
    const _r501 = i0.ɵɵreference(6);
    const ctx_r498 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matMenuTriggerFor", _r501);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(6, _c1));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 4, ctx_r498.unreadCount$));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", notificationsState_r499.isInitialized);
} }
export class NotificationsComponent extends BaseComponent {
    constructor(store) {
        super();
        this.store = store;
    }
    ngAfterViewInit() {
        this.onCloseMenu();
    }
    dispatch(notification, action) {
        this.store.dispatch(new PatchNotificationStatus(notification, action));
    }
    flatten(notification) {
        return flatten(notification);
    }
    onCloseMenu() {
        this.menu.close.pipe(tap(() => this.store.dispatch(MarkNotificationsAsRead)), takeUntil(this.ngUnsubscribe)).subscribe();
    }
}
NotificationsComponent.ɵfac = function NotificationsComponent_Factory(t) { return new (t || NotificationsComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
NotificationsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: NotificationsComponent, selectors: [["app-notifications"]], viewQuery: function NotificationsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(MatMenu, true);
    } if (rf & 2) {
        var _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menu = _t.first);
    } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 3, consts: [[4, "ngIf"], ["mat-icon-button", "", 1, "notifications-icon", 3, "matMenuTriggerFor"], [3, "icon"], ["class", "badge", 3, "hidden", 4, "ngIf"], ["xPosition", "before", 1, "notifications-panel"], ["notificationsMenu", "matMenu"], [1, "badge", 3, "hidden"], [4, "transloco", "translocoRead"], ["class", "padding-64 align-center", 4, "ngIf"], ["id", "wrapper", 3, "click"], [1, "title"], ["class", "padding-16", 4, "ngIf"], ["id", "notifications-list"], ["class", "notification-item", 3, "new", 4, "ngFor", "ngForOf"], [1, "padding-16"], [1, "notification-item"], [1, "type"], [1, "timestamp"], [1, "content"], ["class", "actions", 4, "ngIf"], [1, "actions"], ["class", "final-state", 4, "ngIf"], [1, "final-state"], [4, "ngFor", "ngForOf"], ["buttonTemplate", ""], ["mat-flat-button", "", "color", "primary", 3, "click", 4, "ngIf"], ["mat-stroked-button", "", 3, "click", 4, "ngIf"], ["mat-flat-button", "", "color", "primary", 3, "click"], [4, "ngTemplateOutlet"], ["mat-stroked-button", "", 3, "click"], [1, "padding-64", "align-center"], ["diameter", "32"]], template: function NotificationsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, NotificationsComponent_ng_container_0_Template, 8, 7, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.notificationsState$));
    } }, directives: [i2.NgIf, i3.MatButton, i4.MatMenuTrigger, i5.FaIconComponent, i4._MatMenu, i6.TranslocoDirective, i2.NgForOf, i2.NgTemplateOutlet, i7.MatSpinner], pipes: [i2.AsyncPipe, i2.TitleCasePipe, i2.DatePipe], styles: ["button.notifications-icon[_ngcontent-%COMP%]{background-color:rgba(255,255,255,.12);height:36px;width:36px;position:relative}button.notifications-icon[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{width:20px;position:absolute;top:-4px;right:-4px;background-color:#ff9800;line-height:20px;border-radius:100%}#wrapper[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{background-color:rgba(255,87,34,.12);border-bottom:1px solid rgba(255,87,34,.24);color:#d84315;font-weight:500;padding:16px}#wrapper[_ngcontent-%COMP%]   .title.new[_ngcontent-%COMP%]{background-color:rgba(255,152,0,.12);border-color:rgba(255,152,0,.24);color:#ff9800}#notifications-list[_ngcontent-%COMP%]{max-height:400px;overflow:auto}#notifications-list[_ngcontent-%COMP%]::-webkit-scrollbar{width:10px}#notifications-list[_ngcontent-%COMP%]::-webkit-scrollbar-track{background:#fbe9e7}#notifications-list[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background:#f4511e}#notifications-list[_ngcontent-%COMP%]::-webkit-scrollbar-thumb:hover{background:#e64a19}.notification-item[_ngcontent-%COMP%]{border-bottom:1px solid rgba(0,0,0,.12);padding:16px;display:grid;grid-gap:8px;grid-template-areas:\"type . timestamp\" \"content content content\" \"actions actions actions\"}.notification-item.new[_ngcontent-%COMP%]{background-color:rgba(255,152,0,.04)}.notification-item[_ngcontent-%COMP%]   .final-state[_ngcontent-%COMP%], .notification-item[_ngcontent-%COMP%]   .timestamp[_ngcontent-%COMP%], .notification-item[_ngcontent-%COMP%]   .type[_ngcontent-%COMP%]{font-weight:500;font-size:14px}.notification-item[_ngcontent-%COMP%]   .type[_ngcontent-%COMP%]{color:#ff9800;grid-area:type}.notification-item[_ngcontent-%COMP%]   .timestamp[_ngcontent-%COMP%]{color:#607d8b;grid-area:timestamp;min-width:64px}.notification-item[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{grid-area:content;font-size:14px}.notification-item[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]{grid-area:actions;display:-webkit-box;display:flex;-webkit-box-pack:end;justify-content:flex-end;margin-top:12px}.notification-item[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%] > button[_ngcontent-%COMP%] + button[_ngcontent-%COMP%]{-webkit-margin-start:8px;margin-inline-start:8px}.notification-item[_ngcontent-%COMP%]   .final-state[_ngcontent-%COMP%]{width:100%;text-align:center;color:rgba(191,54,12,.87);padding:12px;background-color:rgba(255,87,34,.12);border-radius:8px}  .notifications-panel{border-radius:8px;max-width:320px}  .notifications-panel .mat-menu-content{padding:0!important}"] });
__decorate([
    Select(NotificationsState.countUnread)
], NotificationsComponent.prototype, "unreadCount$", void 0);
__decorate([
    Select(state => state.notifications)
], NotificationsComponent.prototype, "notificationsState$", void 0);
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(NotificationsComponent, [{
        type: Component,
        args: [{
                selector: 'app-notifications',
                templateUrl: './notifications.component.html',
                styleUrls: ['./notifications.component.scss']
            }]
    }], function () { return [{ type: i1.Store }]; }, { unreadCount$: [], notificationsState$: [], menu: [{
            type: ViewChild,
            args: [MatMenu]
        }] }); })();
